import apiClient from "api-client";

import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useGetForumFeedbackQuestionsQuery = getWrappedUseQuery(
  KEYS.GET_FORUM_FEEDBACK_QUESTIONS,
  apiClient.ForumFeedbackQuestions.get,
);
